import { getContextModules, getComponent } from "@/lib/requireContextHelpers";
import SubscriptionItemView from "./views/SubscriptionItemView/SubscriptionItemView.vue";

const modules = getContextModules(require.context("./views/", true, /\.\/[a-zA-Z]*View\/index.ts/));

export default (item: any) => getComponent(modules, item, SubscriptionItemView);
